var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_Titolo_Corsi_e_Certificazioni",
    "data-name": "icona Titolo Corsi e Certificazioni",
    transform: "translate(0 -8.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_828",
    "data-name": "Tracciato 828",
    d: "M55.559,73.143h17.8a1.036,1.036,0,0,0,0-2.071h-17.8a1.036,1.036,0,0,0,0,2.071Z",
    transform: "translate(-50.769 -57.652)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_829",
    "data-name": "Tracciato 829",
    d: "M55.559,134.006h17.8a1.036,1.036,0,0,0,0-2.071h-17.8a1.036,1.036,0,0,0,0,2.071Z",
    transform: "translate(-50.769 -114.098)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_830",
    "data-name": "Tracciato 830",
    d: "M65,192.8H55.559a1.036,1.036,0,0,0,0,2.071H65a1.036,1.036,0,0,0,0-2.071Z",
    transform: "translate(-50.769 -170.545)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_831",
    "data-name": "Tracciato 831",
    d: "M29.945,37.995,27.35,32.635l1-.418a.9.9,0,0,0,.5-.723l.086-1.344a2.039,2.039,0,0,1,.239-.767l.688-1.14a.937.937,0,0,0,0-.894l-.688-1.14a2.042,2.042,0,0,1-.239-.767L28.858,24.1a.919.919,0,0,0-.393-.663V10.979a2.031,2.031,0,0,0-1.985-2.071H1.985A2.031,2.031,0,0,0,0,10.979V28.715a2.031,2.031,0,0,0,1.985,2.071H17.6l.045.709a.9.9,0,0,0,.5.723l.943.392-2.607,5.385a.331.331,0,0,0-.027.32.192.192,0,0,0,.176.093.461.461,0,0,0,.18-.044l2.136-.933a.456.456,0,0,1,.181-.035.556.556,0,0,1,.407.172l1.026,1.187a.4.4,0,0,0,.3.153.382.382,0,0,0,.337-.254l2.01-4.523h.013l2.01,4.523a.381.381,0,0,0,.338.254.4.4,0,0,0,.3-.154l1.026-1.186A.556.556,0,0,1,27.3,37.4a.456.456,0,0,1,.181.035l2.136.933a.461.461,0,0,0,.18.044.192.192,0,0,0,.176-.093A.33.33,0,0,0,29.945,37.995ZM1.985,10.979H26.479V22.341l-.776-.974a.861.861,0,0,0-.645-.3.662.662,0,0,0-.169.021l-1.252.332a1.9,1.9,0,0,1-.773,0l-1.252-.332a.662.662,0,0,0-.169-.021.861.861,0,0,0-.645.3L19.972,22.4a1.9,1.9,0,0,1-.625.474l-1.2.5a.9.9,0,0,0-.5.723l-.086,1.344a2.038,2.038,0,0,1-.239.767l-.688,1.14a.936.936,0,0,0,0,.894l.284.471H1.985ZM23.25,32.2a4.406,4.406,0,1,1,4.22-4.4A4.314,4.314,0,0,1,23.25,32.2Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseTitle);
export default __webpack_public_path__ + "static/media/course_title.d493e079d884b439d676dc81b44ead70.svg";
export { ForwardRef as ReactComponent };